import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const StyledImagePreview = styled.img`
  width: 600px;
  height: auto;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`

export const StyledIframePreview = styled.iframe`
  width: 600px;
  height: auto;
  cursor: pointer;
`

export const StyledPreviewModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  gap: 10px;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 1002;
`

export const StyledEvidenceImage = styled.img`
  border: 1px solid ${palette.neutral[100]};
  aspect-ratio: auto;
  max-width: 100%;
  flex: 0 1 min-content;
  min-height: 0;
  min-width: 0;
  align-self: center;
  :hover {
    cursor: pointer;
  }
`
export const StyledPreviewModalImage = styled.img`
  max-width: 90%;
  max-height: 90%;
`

export const StyledEvidenceIframe = styled.iframe`
  min-width: 100%;
  width: 100%;
  height: min(75vh, 900px);
  min-height: 420px;
  flex: 1 0 auto;
  flex-grow: 1;
`

export const StyledPreviewModalIframe = styled.iframe`
  width: 90%;
  height: 90%;
  max-width: 90%;
  max-height: 90%;
`

export const PreviewDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 6px;
  :hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`

export const ExpandButtonRow = styled.div`
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
  font-size: 16px;
`

// Stands in for a sheet's grid, framed like one, when it has nothing to show.
// It fills the pane a grid would; the floor is for panes sized by content.
export const SheetMessageFrame = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  border: 1px solid ${palette.neutral['100']};
`

export const StyledCloseButton = styled.div`
  color: ${palette.neutral['50']};
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`

// The title rows a sheet carries above its column names.
export const SheetPreamble = styled.p`
  margin: 0;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  color: ${palette.neutral[600]};
  border: 1px solid ${palette.neutral['100']};
  border-bottom: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

// A sheet's caption and grid, stacked, filling whatever frames them.
export const SheetFrame = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
`
